/*
Name		: quiz.jsx
Created By	: Stephen Amey
Date		: May 16, 2018
----------------------------------------------------------------------------------------------------------------------------------------
Description	: 
	The quiz (survey) component that will be placed in the render HTML of quizBody.jsx. 
	Tracks the users answers as they complete it using .onValueChanged, and displays the appropriate message and resources upon 
	completion with .onComplete
----------------------------------------------------------------------------------------------------------------------------------------
Modification history (- Name, Date : Changes) :


*/

//------------------------------------------------------------------------------------------------------\
//										Imports, requires, CSS											|
//------------------------------------------------------------------------------------------------------/

//Imports----------------------------------/
import * as Survey from "survey-react";

//CSS--------------------------------------/
Survey.defaultBootstrapCss.navigationButton = "btn btn-custom";
Survey.surveyStrings.progressText = "{0} of {1}";

//Requires---------------------------------/
var JSON_Quiz = require(".\\quizJSON.json");
var katex = require('katex');


//------------------------------------------------------------------------------------------------------\
//												Variables												|
//------------------------------------------------------------------------------------------------------/


//Set reference to quiz JSON
var econQuiz = new Survey.Model(JSON.parse(JSON.stringify(JSON_Quiz)));

//User answers
var chosenAnswersMap = new Map(); //A map of each question and the user's answer
var resourcesArray = []; //Array containing which resources to display. Some questions would display the same resources

//Map containing the correct answer for each question
var AnswersMap = new Map(); //["a", "c"] for multiple correct questions
	AnswersMap.set('p1',"d"); 
	AnswersMap.set('p2',"a");
	AnswersMap.set('p3',"c");
	AnswersMap.set('p4',"d");
	AnswersMap.set('p5',"c");
	AnswersMap.set('p6',"b");
	AnswersMap.set('p7',"a");
	AnswersMap.set('p8',"c");
	AnswersMap.set('p9',"b");
	AnswersMap.set('p10',"d");
	AnswersMap.set('p11',"b");
	AnswersMap.set('p12',"c");
	AnswersMap.set('p13',"d");
	AnswersMap.set('p14',"d");
	AnswersMap.set('p15',"c");
	AnswersMap.set('p16',"c");
	AnswersMap.set('p17',"a");
	AnswersMap.set('p18',"b");
	AnswersMap.set('p19',"c");
	AnswersMap.set('p20',"c");
	AnswersMap.set('p21',"c");
	AnswersMap.set('p22',"d");
	AnswersMap.set('p23',"d");
	AnswersMap.set('p24',"a");
	AnswersMap.set('p25',"c");
	AnswersMap.set('p26',"a");
	AnswersMap.set('p27',"d");
	AnswersMap.set('p28',"d");
	AnswersMap.set('p29',"c");
	AnswersMap.set('p30',"a");
	AnswersMap.set('p31',"d");
	AnswersMap.set('p32',"c");
	AnswersMap.set('p33',"c");
	AnswersMap.set('p34',"b");
	AnswersMap.set('p35',"c");

//Map containing which topics to review for whichever questions the user gets wrong
var reviewQuestionMap = new Map();
	//If you want to direct to the resource directly from the results page, use this and change the resource array addition below
	//at Line 160, comment the other and uncomment 'htmlHeadText += ...'
	/*reviewQuestionMap.set('p1',["resource name", "some link1"]);
	reviewQuestionMap.set('p2',["resource name2", "some link2"]);
	reviewQuestionMap.set('p3',["resource name3", "some link3"]);
	reviewQuestionMap.set('p4',["resource name3", "some link3"]);
	reviewQuestionMap.set('p5',["google link here", "https://www.google.ca/"]);*/
	
	reviewQuestionMap.set('p1',"Math preliminaries");
	reviewQuestionMap.set('p2',"Math preliminaries");
	reviewQuestionMap.set('p3',"Math preliminaries");
	reviewQuestionMap.set('p4',"Math preliminaries");
	reviewQuestionMap.set('p5',"Linear equations: functions and graphs");
	reviewQuestionMap.set('p6',"Linear equations: functions and graphs");
	reviewQuestionMap.set('p7',"Linear equations: functions and graphs");
	reviewQuestionMap.set('p8',"Linear equations: functions and graphs");
	reviewQuestionMap.set('p9',"Linear equations: functions and graphs");
	reviewQuestionMap.set('p10',"Linear equations: functions and graphs");
	reviewQuestionMap.set('p11',"Linear equations: functions and graphs");
	reviewQuestionMap.set('p12',"Linear equations: functions and graphs");
	reviewQuestionMap.set('p13',"Simultaneous equations");
	reviewQuestionMap.set('p14',"Simultaneous equations");
	reviewQuestionMap.set('p15',"Simultaneous equations");
	reviewQuestionMap.set('p16',"Simultaneous equations");
	reviewQuestionMap.set('p17',"Simultaneous equations");
	reviewQuestionMap.set('p18',"Rules of differentiation");
	reviewQuestionMap.set('p19',"Rules of differentiation");
	reviewQuestionMap.set('p20',"Rules of differentiation");
	reviewQuestionMap.set('p21',"Rules of differentiation");
	reviewQuestionMap.set('p22',"Rules of differentiation");
	reviewQuestionMap.set('p23',"Rules of differentiation");
	reviewQuestionMap.set('p24',"Rules of differentiation");
	reviewQuestionMap.set('p25',"Uses of the derivative");
	reviewQuestionMap.set('p26',"Uses of the derivative");
	reviewQuestionMap.set('p27',"Uses of the derivative");
	reviewQuestionMap.set('p28',"Uses of the derivative");
	reviewQuestionMap.set('p29',"Uses of the derivative");
	reviewQuestionMap.set('p30',"Uses of the derivative");
	reviewQuestionMap.set('p31',"Uses of the derivative");
	reviewQuestionMap.set('p32',"Uses of the derivative");
	reviewQuestionMap.set('p33',"Uses of the derivative");
	reviewQuestionMap.set('p34',"Uses of the derivative");
	reviewQuestionMap.set('p35',"Uses of the derivative");
	

//Total questions and questions correct
var totalQuestions = AnswersMap.size;
var correctQuestions = 0;

//Starts the timer
econQuiz.startTimer();

//econQuiz.currentPage = econQuiz.pages[25];
export default econQuiz;


//------------------------------------------------------------------------------------------------------\
//										 SurveyJS event methods											|
//------------------------------------------------------------------------------------------------------/


/*
Purpose:
	-Finds number of correct questions, pushes incorrect questions to array to later display review resources.
*/
econQuiz.onComplete.add(function (result) {
	correctQuestions = 0;
	var tableHtml = "<br><br><table>";
	tableHtml += "<tr><td>Question</td><td>Your answer</td><td>Correct answer</td><td>Result</td><td>Review content</td></tr>";
	AnswersMap.forEach(function (value, key, map){
		tableHtml += "<tr id=\"__" + key.substring(1) + "\"><td class=\"tr_ID\">" + key.substring(1)
				  + "</td><td>" + (chosenAnswersMap.get(key) == null ? "" : chosenAnswersMap.get(key))
				  + "</td><td>" + AnswersMap.get(key)
				  + "</td><td>" + (isEqual(chosenAnswersMap.get(key), AnswersMap.get(key)) === true ? "&#x2713;" : "&#x2715;")
				  + "</td><td>" + reviewQuestionMap.get(key)
				  + "</td></tr>";		
			if(isEqual(chosenAnswersMap.get(key), AnswersMap.get(key)))
				correctQuestions++;
			else if(resourcesArray.indexOf(reviewQuestionMap.get(key)) === -1) //If the resource is not already in the array
				resourcesArray.push(reviewQuestionMap.get(key)); //Adds the resource to be displayed to the array	
	});

	//Finds the user's score, time spent, creates start of html text
	var date = new Date(null);
	date.setSeconds(econQuiz.timeSpent);
	var scorePercent = Math.round(correctQuestions/totalQuestions * 100)/100;
	var htmlHeadText = ("<h4>Score</h4><p>" + Math.round(scorePercent*100) + "%</p><h4>Time</h4><p>" + date.toISOString().substr(11, 8) + "</p><p><h4>Interpretation</h4></p>");
	
	if(scorePercent >= 0.9)
		htmlHeadText += "<p>Very good</p><h4>Recommendations</h4><p>If more than one mistake and (or) more than one ‘I don’t know’ option in a section, review the basic concepts of that section.</p>";
	else if (scorePercent >= 0.8)
		htmlHeadText += "<p>Good</p><h4>Recommendations</h4><p>If more than one mistake and (or) more than one ‘I don’t know’ option in a section, review the basic concepts of that section.</p>";
	else if (scorePercent >= 0.7)
		htmlHeadText += "<p>Fair</p><h4>Recommendations</h4><p>If more than one mistake and (or) more than one ‘I don’t know’ option in a section, review the basic concepts of that section.</p><p>If necessary, explore the opportunities of getting help offered through the Economics Drop-In Help Centre & Private Tutor List in the resources.</p>";
	else
		htmlHeadText += "<p>Poor</p><h4>Recommendations</h4><p>If more than one mistake and (or) more than one ‘I don’t know’ option in a section, review the basic concepts of that section</p><p>If the math-related problem continues, explore the opportunities of getting help offered through the Economics Drop-In Help Centre & Private Tutor List in the resources.</p>";

	//If not a perfect score, display resources
	if(scorePercent !== 1){
		htmlHeadText += "<h4>Areas to review</h4>";	
		htmlHeadText += "<ul class=\"squarelist\">";
		resourcesArray.forEach(function(resource){
			//htmlHeadText += ("<br><a href=" + resource[1] + ">" + resource[0] + "</a>"); //If we want to link it to the resource directly
			htmlHeadText += ("<li>" + resource + "</li>");
		});		
		htmlHeadText += "</ul>";
	}
	
	tableHtml += "</table>";
	htmlHeadText += tableHtml;
	
	//Sets the completedHtml text
	econQuiz.completedHtml = htmlHeadText
});

/*
Purpose:
	-Sets the user's answer choice in the chosen answers map each time they make a selection.
*/
econQuiz.onValueChanged.add(function (sender, options){
	chosenAnswersMap.set(options.name,options.value);
});

/*
Purpose:
	-Changes the format of the progress bar's text, as there is not enough room on the first page for the full text
*/
econQuiz.onCurrentPageChanged.add(function (sender, options){
	if(econQuiz.currentPageNo < 2)
		Survey.surveyStrings.progressText = "{0}";
	else
		Survey.surveyStrings.progressText = "{0} of {1}";
});

/*
Purpose:
	-On setting the text for the SurveyJS object, converts the custom KaTex tag ~$ ... ~ into KaTex HTML. 
	-Sets all text as HTML.
*/
econQuiz.onTextMarkdown.add(function (econQuiz, options) {
	var str = "";
	var line = options.text.split('~');	
	//for (let segment of line){
	line.forEach(function (segment){
		if(segment.charAt(0) === '$'){
			segment = segment.substring(1);
			str += katex.renderToString(segment);
		}
		else{
			str += segment;
		}	
	});
    options.html = str;
});

document.addEventListener('click', function(event) {
	//If the row itself was somehow clicked
	if(event.target.id.substring(0,2) === '__'){
		econQuiz.firstPageIsStarted = false;
		econQuiz.clear(false, true);
		econQuiz.currentPage = econQuiz.pages[parseInt(event.target.id.substring(2), 10)];
		econQuiz.startTimer();
		econQuiz.render();
	}
	//If a childen data cell item was clicked
	else if (event.target.parentElement.id.substring(0,2) === '__'){	
		econQuiz.firstPageIsStarted = false;
		econQuiz.clear(false, true);
		econQuiz.currentPage = econQuiz.pages[parseInt(event.target.parentElement.id.substring(2), 10)];	
		econQuiz.startTimer();
		econQuiz.render();
	}	
}, false);


//------------------------------------------------------------------------------------------------------\
//											  Misc Functions											|
//------------------------------------------------------------------------------------------------------/


/*
Purpose:
	-Compare the two inputs for equality (works for single and multiple choice)
Parameters:
	-Two strings, numbers, or arrays
*/
function isEqual(a, b) {
	if (a === b) return true; //Will return true if single choice and matches
	if (!(a instanceof Array) && !(b instanceof Array)) return false; //If it was single choice and did not match, return false
	
	if (a == null) return false; //If no answer was given
	if (a.length !== b.length) return false; //If the length differs

	//Sorts the arrays
	a.sort();
	b.sort();

	//compares the arrays
	for (var i = 0; i < a.length; ++i) {
		if (a[i] !== b[i]) return false;
	}
	return true;
}


// WEBPACK FOOTER //
// ./src/Components/quiz.jsx